import { UserActionTypeArea } from '@common/enums';
import { DisplayNameDictionary } from '@common/types';

/**
 * `UserActionTypeArea` is `event` in model and form
 */
export const UserActionTypeAreaMap: Partial<DisplayNameDictionary> = {
  [UserActionTypeArea.AutoActivationMode]: {
    displayName: 'Auto-Activation mode'
  },
  [UserActionTypeArea.AlternateEmailChanged]: {
    displayName: 'Alternate email changed'
  },
  [UserActionTypeArea.ArchiveOptionsChanged]: {
    displayName: 'Archive options changed'
  },
  [UserActionTypeArea.BackupConfigured]: {
    displayName: 'Backup configured'
  },
  [UserActionTypeArea.BackupDeleted]: {
    displayName: 'Backup deleted'
  },
  [UserActionTypeArea.BackupOptionsChanged]: {
    displayName: 'Backup options changed'
  },
  [UserActionTypeArea.SharedDrivesBackupOptions]: {
    displayName: 'Shared Drives backup options'
  },
  [UserActionTypeArea.ContentViewed]: {
    displayName: 'Content viewed'
  },
  [UserActionTypeArea.Deletion]: {
    displayName: 'Change'
  },
  [UserActionTypeArea.Downloaded]: {
    displayName: 'Downloaded'
  },
  [UserActionTypeArea.Export]: {
    displayName: 'Export'
  },
  [UserActionTypeArea.PageVisited]: {
    displayName: 'Page visited'
  },
  [UserActionTypeArea.PermissionsSet]: {
    displayName: 'Permissions set'
  },
  [UserActionTypeArea.Restore]: {
    displayName: 'Restore'
  },
  [UserActionTypeArea.RetentionPolicyChanged]: {
    displayName: 'Retention policy changed'
  },
  [UserActionTypeArea.TaskPerformed]: {
    displayName: 'Task performed'
  },
  [UserActionTypeArea.ExportSettingsChanged]: {
    displayName: 'Export settings changed'
  },
  [UserActionTypeArea.EmailReportSettingsChanged]: {
    displayName: 'Email report settings changed'
  }
};
